// extracted by mini-css-extract-plugin
export default {"container":"PagePopup__container--2Lm","header":"PagePopup__header--3aK","noPadding":"PagePopup__noPadding--1aB","inner":"PagePopup__inner--3Mv","close":"PagePopup__close--32N"};